import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetStandbyTravelersResultEffect } from './get-standby-travelers-result.effect';
import { getStandbyTravelersResultReducer } from './get-standby-travelers-result.reducer';
import {
  GET_STANDBY_TRAVELERS_RESULT_STORE_NAME,
  GetStandbyTravelersResultState,
} from './get-standby-travelers-result.state';

/** Token of the GetStandbyTravelersResult reducer */
export const GET_STANDBY_TRAVELERS_RESULT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<GetStandbyTravelersResultState, Action>
>('Feature GetStandbyTravelersResult Reducer');

/** Provide default reducer for GetStandbyTravelersResult store */
export function getDefaultGetStandbyTravelersResultReducer() {
  return getStandbyTravelersResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_STANDBY_TRAVELERS_RESULT_STORE_NAME, GET_STANDBY_TRAVELERS_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([GetStandbyTravelersResultEffect]),
  ],
  providers: [
    { provide: GET_STANDBY_TRAVELERS_RESULT_REDUCER_TOKEN, useFactory: getDefaultGetStandbyTravelersResultReducer },
  ],
})
export class GetStandbyTravelersResultStoreModule {
  public static forRoot<T extends GetStandbyTravelersResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetStandbyTravelersResultStoreModule> {
    return {
      ngModule: GetStandbyTravelersResultStoreModule,
      providers: [{ provide: GET_STANDBY_TRAVELERS_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
